"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadDocument = exports.saveSsnAndConsent = exports.saveSsn = exports.saveRegistrationConsents = exports.saveProfileAndHelocReasonAndConsent = exports.saveProfile = exports.savePhone = exports.saveName = exports.saveMaritalStatus = exports.saveIncomeAndConsent = exports.saveIncome = exports.saveConsentsAndHeloc = exports.saveConsents = exports.saveConsent = exports.saveAddress = exports.getProfile = exports.getMaritalTypes = exports.getConsentTypes = exports.getAddressTypes = exports.UPLOAD_DOCUMENT = exports.SAVE_SSN = exports.SAVE_PROFILE = exports.SAVE_PHONE = exports.SAVE_NAME = exports.SAVE_MARITAL_STATUS = exports.SAVE_INCOME = exports.SAVE_CONSENT_LIST = exports.SAVE_CONSENT = exports.SAVE_ADDRESS = exports.GET_PROFILE = exports.GET_MARITAL_TYPES = exports.GET_CONSENT_TYPES = exports.GET_ADDRESS_TYPES = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var _helocActions = require("./heloc-actions");

var GET_ADDRESS_TYPES = 'GET_ADDRESS_TYPES';
exports.GET_ADDRESS_TYPES = GET_ADDRESS_TYPES;
var GET_CONSENT_TYPES = 'GET_CONSENT_TYPES';
exports.GET_CONSENT_TYPES = GET_CONSENT_TYPES;
var GET_MARITAL_TYPES = 'GET_MARITAL_TYPES';
exports.GET_MARITAL_TYPES = GET_MARITAL_TYPES;
var GET_PROFILE = 'GET_PROFILE';
exports.GET_PROFILE = GET_PROFILE;
var SAVE_PROFILE = 'SAVE_PROFILE';
exports.SAVE_PROFILE = SAVE_PROFILE;
var SAVE_NAME = 'SAVE_NAME';
exports.SAVE_NAME = SAVE_NAME;
var SAVE_MARITAL_STATUS = 'SAVE_MARITAL_STATUS';
exports.SAVE_MARITAL_STATUS = SAVE_MARITAL_STATUS;
var SAVE_PHONE = 'SAVE_PHONE';
exports.SAVE_PHONE = SAVE_PHONE;
var SAVE_ADDRESS = 'SAVE_ADDRESS';
exports.SAVE_ADDRESS = SAVE_ADDRESS;
var SAVE_INCOME = 'SAVE_INCOME';
exports.SAVE_INCOME = SAVE_INCOME;
var SAVE_SSN = 'SAVE_SSN';
exports.SAVE_SSN = SAVE_SSN;
var SAVE_CONSENT = 'SAVE_CONSENT';
exports.SAVE_CONSENT = SAVE_CONSENT;
var SAVE_CONSENT_LIST = 'SAVE_CONSENT_LIST';
exports.SAVE_CONSENT_LIST = SAVE_CONSENT_LIST;
var UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
exports.UPLOAD_DOCUMENT = UPLOAD_DOCUMENT;
var CONTEXT = '/service-profile/api/v1/profile';

var getAddressTypes = function getAddressTypes() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_ADDRESS_TYPES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/address-types")));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getAddressTypes = getAddressTypes;

var getConsentTypes = function getConsentTypes() {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxGet)(GET_CONSENT_TYPES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/consent-types")));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * @deprecated Replaced by heloc action
 */


exports.getConsentTypes = getConsentTypes;

var getMaritalTypes = function getMaritalTypes(primaryState) {
  var secondaryState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : primaryState;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(GET_MARITAL_TYPES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/marital-types?primaryState=").concat(primaryState).concat(secondaryState ? "&secondaryState=".concat(secondaryState) : '')));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getMaritalTypes = getMaritalTypes;

var getProfile = function getProfile() {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(GET_PROFILE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT)));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getProfile = getProfile;

var saveProfile = function saveProfile(data) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxPut)(SAVE_PROFILE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT), data));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.saveProfile = saveProfile;

var saveName = function saveName(data) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxPut)(SAVE_NAME, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/name"), data));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.saveName = saveName;

var saveMaritalStatus = function saveMaritalStatus(data) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxPut)(SAVE_MARITAL_STATUS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/marital-status"), data));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};

exports.saveMaritalStatus = saveMaritalStatus;

var savePhone = function savePhone(data) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxPut)(SAVE_PHONE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/phone"), data));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.savePhone = savePhone;

var saveAddress = function saveAddress(data) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (0, _ajax.ajaxPut)(SAVE_ADDRESS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/address"), data));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.saveAddress = saveAddress;

var saveIncome = function saveIncome(data) {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(dispatch) {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (0, _ajax.ajaxPut)(SAVE_INCOME, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/income"), data));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};

exports.saveIncome = saveIncome;

var saveSsn = function saveSsn(data) {
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(dispatch) {
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", (0, _ajax.ajaxPut)(SAVE_SSN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/ssn"), data));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
};

exports.saveSsn = saveSsn;

var saveConsent = function saveConsent(data) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(dispatch) {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", (0, _ajax.ajaxPut)(SAVE_CONSENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/consent"), data));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
};

exports.saveConsent = saveConsent;

var saveConsents = function saveConsents(data) {
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(dispatch) {
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", (0, _ajax.ajaxPut)(SAVE_CONSENT_LIST, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/consent-list"), data));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x13) {
      return _ref13.apply(this, arguments);
    };
  }();
};
/**
 * Saves all consents that are required for registration.
 */


exports.saveConsents = saveConsents;

var saveRegistrationConsents = function saveRegistrationConsents() {
  return /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(dispatch) {
      var consentTypes, registrationConsents;
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return dispatch(getConsentTypes());

            case 2:
              consentTypes = _context14.sent;
              registrationConsents = consentTypes.filter(function (t) {
                return ['TERMS', 'PRIVACY', 'COMMUNICATIONS'].includes(t.type);
              }) // We need to explicitly pass `optInOut: 'OPT_IN'`
              .map(function (t) {
                return {
                  type: t.type,
                  version: t.version,
                  optInOut: 'OPT_IN'
                };
              });
              dispatch(saveConsents({
                consents: registrationConsents
              }));

            case 5:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x14) {
      return _ref14.apply(this, arguments);
    };
  }();
};

exports.saveRegistrationConsents = saveRegistrationConsents;

var uploadDocument = function uploadDocument(type, file, onProgress) {
  return /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(dispatch) {
      var form;
      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              form = new FormData(); // eslint-disable-line new-cap

              form.append('file', file);
              return _context15.abrupt("return", (0, _ajax.formPost)(UPLOAD_DOCUMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/document/").concat(type), form, {
                type: type,
                file: file
              }, onProgress));

            case 3:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x15) {
      return _ref15.apply(this, arguments);
    };
  }();
};

exports.uploadDocument = uploadDocument;

var saveConsentsAndHeloc = function saveConsentsAndHeloc(data) {
  return /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(dispatch) {
      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", dispatch(saveConsents({
                consents: data.consents
              })).then(function () {
                return dispatch((0, _helocActions.saveHeloc)(data.promoCode));
              }));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x16) {
      return _ref16.apply(this, arguments);
    };
  }();
};

exports.saveConsentsAndHeloc = saveConsentsAndHeloc;

var saveProfileAndHelocReasonAndConsent = function saveProfileAndHelocReasonAndConsent(data) {
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(dispatch) {
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", dispatch(saveProfile({
                name: {
                  uuid: data.name.uuid || null,
                  firstName: data.name.firstName,
                  lastName: data.name.lastName,
                  dob: data.name.dob // TODO: make sure app that uses this fixes date format
                  // citizenship: data.name.citizenship

                },
                maritalStatus: {
                  type: data.maritalStatus.type
                },
                homeAddress: {
                  uuid: data.homeAddress.uuid || null,
                  street1: data.homeAddress.address,
                  street2: data.homeAddress.address2,
                  city: data.homeAddress.city,
                  state: data.homeAddress.state,
                  zip: data.homeAddress.zip,
                  type: 'HOME'
                },
                assetAddress: data.isHomeFinancing && data.propertyAddress.address ? {
                  uuid: data.propertyAddress.uuid || null,
                  street1: data.propertyAddress.address,
                  street2: data.propertyAddress.address2,
                  city: data.propertyAddress.city,
                  state: data.propertyAddress.state,
                  zip: data.propertyAddress.zip,
                  type: data.propertyAddress.type
                } : null,
                income: {
                  uuid: data.income.uuid || null,
                  amount: data.income.amount
                }
              })).then(function (profileResponse) {
                var homeAddress = profileResponse.addresses.reverse().find(function (a) {
                  return a.type === 'HOME';
                });
                var propertyAddress = profileResponse.addresses.reverse().find(function (a) {
                  return a.type === data.propertyAddress.type;
                });
                return dispatch((0, _helocActions.saveProperty)({
                  helocUuid: data.heloc.uuid,
                  propertyUuid: data.isHomeFinancing === 'YES' ? homeAddress.uuid : propertyAddress.uuid
                }));
              }).then(function () {
                return dispatch((0, _helocActions.saveReason)({
                  helocUuid: data.heloc.uuid,
                  reason: data.heloc.reason
                }));
              }).then(function () {
                return dispatch((0, _helocActions.saveConsent)({
                  helocUuid: data.heloc.uuid,
                  type: data.heloc.consent.type,
                  version: data.heloc.consent.version
                }));
              }));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x17) {
      return _ref17.apply(this, arguments);
    };
  }();
};

exports.saveProfileAndHelocReasonAndConsent = saveProfileAndHelocReasonAndConsent;

var saveIncomeAndConsent = function saveIncomeAndConsent(data) {
  return /*#__PURE__*/function () {
    var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(dispatch) {
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", dispatch(saveIncome(data.income)).then(function () {
                return dispatch((0, _helocActions.saveConsent)(data.consent));
              }));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x18) {
      return _ref18.apply(this, arguments);
    };
  }();
};

exports.saveIncomeAndConsent = saveIncomeAndConsent;

var saveSsnAndConsent = function saveSsnAndConsent(data) {
  return /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(dispatch) {
      return _regenerator.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", dispatch(saveSsn({
                ssn: data.ssn
              })).then(function () {
                return dispatch((0, _helocActions.saveConsent)(data.consent));
              }));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x19) {
      return _ref19.apply(this, arguments);
    };
  }();
};

exports.saveSsnAndConsent = saveSsnAndConsent;